/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Protocolo } from '@/models/Protocolo';
import Spinner from '@/components/Spinner';

import {
  Input,
  InputContent,
  InputIcon,
  InputLoadingContainer,
  InputText,
} from './styles';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  protocolo: Protocolo;
  disabled?: boolean;
  loading?: boolean;
}

const InputProtocolo: React.FC<Props> = ({
  protocolo,
  disabled,
  loading,
  ...props
}) => {
  return (
    <Input {...props} $disabled={disabled} $loading={loading}>
      <InputContent>
        <InputIcon src={protocolo.imagem_url} alt="" />
        <InputText>{protocolo.nome}</InputText>
      </InputContent>

      {loading && (
        <InputLoadingContainer>
          <Spinner size={16} />
        </InputLoadingContainer>
      )}
    </Input>
  );
};

export default InputProtocolo;
